import { render, staticRenderFns } from "./afrInfo.vue?vue&type=template&id=41af61f0&"
import script from "./afrInfo.vue?vue&type=script&lang=js&"
export * from "./afrInfo.vue?vue&type=script&lang=js&"
import style0 from "./afrInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41af61f0')) {
      api.createRecord('41af61f0', component.options)
    } else {
      api.reload('41af61f0', component.options)
    }
    module.hot.accept("./afrInfo.vue?vue&type=template&id=41af61f0&", function () {
      api.rerender('41af61f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/ams/afrInfo.vue"
export default component.exports